module.exports = __webpack_public_path__ + "static/media/img40.31596e8f.jpg";